import React, { useState, useEffect } from "react";
import {
    Paper,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
} from "@material-ui/core";
import BackupIcon from "@material-ui/icons/Backup";
import { RemoveRedEye as ViewIcon } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

import moment from "moment";

import styled from "styled-components";
import { StyledHeader } from "../../../styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import ErrorRoundedIcon from "@material-ui/icons/ErrorRounded";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    colorPrimary: {
        backgroundColor: "#A7A6A6",
    },
    barColorPrimary: {
        backgroundColor: "#4caf50",
    },
    colorSecondary: {
        backgroundColor: "#A7A6A6",
    },
    barColorSecondary: {
        backgroundColor: "#0188cc",
    },
});

const StyledPaper = styled(Paper)`
    width: 100%;
    border: 1px solid blue;
`;

const QualificationTableRow = styled(TableRow)`
    margin-top: 2.5px !important;
    margin-bottom: 2.5px !important;
`;
const QualificationImg = styled.img`
    width: 50px;
    height: 50px;
    float: right;
    margin-left: 25px;
    margin-right: 25px;
    margin-top: 5px;
    margin-bottom: 5px;
`;
export default (props) => {
    const [category_info, setCategoryInfo] = useState(props.category_info);
    const [numberOfQualifications, setNumberOfQualifications] = useState(
        props.category_info.qualsInCategory.length
    );
    const [qualifications, setQualifications] = useState(
        props.category_info.qualsInCategory
    );
    const classes = useStyles();
    useEffect(() => {
        setCategoryInfo(props.category_info);
        setNumberOfQualifications(props.category_info.qualsInCategory.length);
        setQualifications(props.category_info.qualsInCategory);
    }, [props.category_info]);
    let progress = Math.floor(
        (category_info.completed / numberOfQualifications) * 100
    );
    return (
        <StyledPaper style={{ borderWidth: "0.5px", borderColor: "#0188cc" }}>
            <StyledHeader
                style={{
                    height: "fit-content",
                    width: "100%",
                    backgroundColor: "#0188cc",
                    color: "white",
                    padding: "none",
                }}
            >
                {" "}
                {category_info.category}{" "}
            </StyledHeader>

            <div
                style={{
                    marginLeft: "15px",
                    marginRight: "15px",
                }}
            >
                <Typography
                    variant="body2"
                    style={{
                        marginTop: "5px",
                        marginBottom: "5px",
                        color: "#0188cc",
                    }}
                >
                    Completed
                </Typography>
                <div className={classes.root}>
                    {progress === 100 ? (
                        <LinearProgress
                            variant="determinate"
                            classes={{
                                colorPrimary: classes.colorPrimary,
                                barColorPrimary: classes.barColorPrimary,
                            }}
                            value={progress}
                            style={{ height: "8px" }}
                        />
                    ) : (
                        <LinearProgress
                            variant="determinate"
                            classes={{
                                colorPrimary: classes.colorSecondary,
                                barColorPrimary: classes.barColorSecondary,
                            }}
                            value={progress}
                            style={{ height: "8px" }}
                        />
                    )}
                </div>

                <div className="text-center" style={{ color: "#0188cc" }}>
                    {" "}
                    <b>{progress} % </b>{" "}
                </div>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeadCell text="Qualification Name" />
                            <TableHeadCell text="Expiry Date" />
                            <TableHeadCell text="Time Left" />
                            <TableHeadCell text="Verified" />
                            <TableHeadCell text="View" />
                            {props.canUpdate ? (
                                <TableHeadCell
                                    style={{ color: "#0188cc" }}
                                    text="Upload"
                                />
                            ) : (
                                ""
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {qualifications &&
                            qualifications.map((qualification, i) => {
                                let img = qualification.valid
                                    ? qualification.qualification_valid_img
                                    : qualification.qualification_invalid_img;
                                let timeLeft = getTimeLeft(
                                    qualification.qualification_exp_date
                                );
                                return (
                                    <QualificationTableRow key={i}>
                                        <TableCell
                                            style={{
                                                width: 215,
                                            }}
                                            padding="none"
                                        >
                                            <div
                                                style={{
                                                    display: "inline-flex",
                                                }}
                                            >
                                                <Typography
                                                    style={{
                                                        width: 130,
                                                        color: "#A0A0A0",
                                                    }}
                                                    variant="body2"
                                                >
                                                    {
                                                        qualification.qualification_title
                                                    }
                                                </Typography>
                                                <QualificationImg
                                                    src={img}
                                                    alt={
                                                        qualification.qualification_title
                                                    }
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell padding="none">
                                            <Typography
                                                variant="body2"
                                                style={{ color: "#A0A0A0" }}
                                            >
                                                {
                                                    qualification.qualification_exp_date
                                                }
                                            </Typography>
                                        </TableCell>
                                        <TableCell padding="none">
                                            <Typography
                                                style={{
                                                    marginRight: 5,
                                                    marginLeft: 5,
                                                    color: "#A0A0A0",
                                                }}
                                                variant="body2"
                                            >
                                                {timeLeft !== false
                                                    ? `${timeLeft._data.years} Yrs ${timeLeft._data.months} \n Mts ${timeLeft._data.days} Dys`
                                                    : "Expired"}
                                            </Typography>
                                        </TableCell>
                                        <TableCell padding="none">
                                            {qualification.qualification_verified ===
                                            "Yes" ? (
                                                <CheckCircleRoundedIcon
                                                    style={{
                                                        color: "#4caf50",
                                                        borderRadius: "25px",
                                                    }}
                                                />
                                            ) : (
                                                <ErrorRoundedIcon
                                                    style={{
                                                        color: "#fe0403 ",
                                                        borderRadius: "25px",
                                                    }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell padding="none">
                                            <ViewIcon
                                                style={{
                                                    color: "#0188cc",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                    props.setViewQualificationModalState(
                                                        true
                                                    );
                                                    props.setSelectedQualification(
                                                        qualification
                                                    );
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell padding="none">
                                            {props.canUpdate ? (
                                                <BackupIcon
                                                    style={{
                                                        color: "#0188cc",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                        props.setEditQualificationModalState(
                                                            true
                                                        );
                                                        props.setSelectedQualification(
                                                            qualification
                                                        );
                                                    }}
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </TableCell>
                                    </QualificationTableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </div>
        </StyledPaper>
    );
};

const TableHeadCell = ({ text }) => {
    return (
        <TableCell padding="none">
            <Typography variant="caption" style={{ color: "#0188cc" }}>
                {text}
            </Typography>
        </TableCell>
    );
};
const getTimeLeft = (expiryDate) => {
    let currentDate = moment();
    let expDate = moment(expiryDate, "DD/MM/YYYY");
    let duration = moment.duration(expDate.diff(currentDate));
    if (duration._isValid) {
        return duration;
    } else {
        return false;
    }
};
